import articleSearchTagsEvents from '../../events/articleSearchTags.events'
import ArticleSearchTagModalContent from '../ArticleSearchTagModalContent'
import eventBus from '../../../../../../../services/eventBus'
import faqApi from '../../../../faq.api'
import useStateWithChange from 'shared/hooks/useStateWithChange'
import { IFaqArticleSearchTag } from '../../../../faq.types'
import useHttpLoader from '../../../../../../../shared/hooks/useHttpLoader'

interface ICreateArticleSearchTagModalProps {
  onClose: () => void
  onSuccess?: (tag: IFaqArticleSearchTag) => void
}

const CreateArticleSearchTagModal = ({ onClose, onSuccess }: ICreateArticleSearchTagModalProps) => {
  const { wait, loading } = useHttpLoader()

  const [state, _, handleChange] = useStateWithChange<Pick<IFaqArticleSearchTag, 'name'>>({
    name: '',
  })

  const handleSubmit = () => {
    wait(faqApi.createArticleSearchTag({ name: state.name.trim() }), (resp) => {
      if (resp.status === 'success') {
        articleSearchTagsEvents.created(resp.body)
        eventBus.pub('ntf.message', { message: 'Тег создан', type: 'info' })
        onSuccess?.(resp.body)
        onClose()
      }
    })
  }

  return (
    <ArticleSearchTagModalContent
      title='Создание поискового тега'
      onClose={onClose}
      onChange={handleChange}
      onSave={handleSubmit}
      state={state}
      loading={loading}
    />
  )
}

export default CreateArticleSearchTagModal
